<template>
  <div :class="`main_navbar_tb ${navbar_status.show?'menu_bar_open':''}`">
    <div class="logo_area">
      <img src="../../assets/images/logo.png"/>
      <div class="logo_name">
        <span class="logo_name_1">{{common_sys_name}}</span>
        <span class="logo_name_2">Simplified Weighing System Backend</span>
      </div>
    </div>
    <div class="menu_bar_top">
      <template v-for="(item,i) of menus.rows">
        <div :ref="item.levelCode" v-if="item.levelCode.length == 3" :class="`item_parent no_select point_hand`">
          <div :class="`item-title ${current_code.startsWith(item.levelCode)?'menu_active':''} ${current_open==item.levelCode?'menu_click':''}`" @click="fun_click_menu(item.levelCode)">
            <span>{{ item.resourceName }}</span>
          </div>
        </div>
        <template v-else></template>
      </template>
    </div>
    <div class="right_menu">
      <div class="nav_user" @click="fun_open_setting">
        <img src="@/assets/images/headimage.png" />
        <span class="user_name">{{current_user.userName}}</span>
        <span class="user_ip">{{ip}}</span>
      </div>
<!--      <div class="nav_hover" @click="fun_open_setting"><i class="el-icon-setting ficon"></i></div>-->
      <div class="nav_hover" @click="fun_togger_fullscreen"><i class="el-icon-full-screen ficon"></i></div>
      <div class="nav_hover" @click="$router.push('/back/dashboard')"><i class="el-icon-s-home ficon"></i></div>
<!--      <div class="nav_hover" @click="$router.push('/back/analysis/tree_map')" title="统计图表"><i class="el-icon-pie-chart ficon"></i></div>-->
    </div>
    <CompSetting v-if="dialog_setting.show" :dialog="dialog_setting"></CompSetting>
    <ChangePasswordForm v-if="dialog.show" :dialog="dialog"></ChangePasswordForm>
    <div style="clear:both;"></div>
    <div class="menu_bar_level2" v-if="navbar_status.show">
      <div :style="`width:${left_space}px;float:left;`">&nbsp;</div>
      <div v-for="ntem in navbar_status.menus" :class="`menu_bar_item ${ntem.levelCode==current_code?'select':''}`" @click="fun_open_page(ntem)">
        <i :class="'fa ' + ntem.defaultPicture" style="" />
        <div class="menu_tit">{{ntem.resourceName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePasswordForm from '@/components/common/ChangePasswordForm.vue'
import CompSetting from "@/components/CompSetting.vue";
import {fun_convert_to_string} from "@/utils/common";

export default {
  props:['navbar_status'],
  components: {ChangePasswordForm,CompSetting},
  data() {
    return {
      dialog: {show:false},
      dialog_setting:{show:false},
      cur: 0,
      current_user: {},
      menus:{rows:[]},
      common_sys_name:'',
      current_code:'',
      current_open:'',
      left_space:0,
      ip:'0.0.0.0',
      // navbar_status:{show:false,current_code:'',menus:[]},
    };
  },
  methods: {
    fun_open_page(_v){
      zyl.show_loading();
      this.current_code=_v.levelCode;
      this.current_open='';
      Object.assign(this.navbar_status,{show:false,current_node:_v.levelCode,})
      this.$router.push({path:_v.url,query:_v.functionParameter?JSON.parse(_v.functionParameter):{}});
    },
    fun_open_setting(){Object.assign(this.dialog_setting,{show:!this.dialog_setting.show});},
    fun_togger_fullscreen(){
      if(document.fullscreenElement) document.exitFullscreen();
      else document.documentElement.requestFullscreen();
    },
    fun_click_menu(_code){
      if(_code==this.current_open){
        this.current_open='';
        Object.assign(this.navbar_status,{show:false,current_code:''})
        return;
      }
      this.current_open = _code;
      this.navbar_status.menus.length=0;
      this.menus.rows.forEach(n=>{
        if(!n.levelCode.startsWith(_code)||n.levelCode.length!=6)return;
        this.navbar_status.menus.push(n);
      });

      this.left_space = (this.$refs[_code][0].offsetLeft+58)-((this.navbar_status.menus.length*120)/2);
      if(this.left_space+this.navbar_status.menus.length*120>document.body.clientWidth)
        this.left_space = document.body.clientWidth - this.navbar_status.menus.length*120;
      Object.assign(this.navbar_status,{show:true,current_code:_code})
    },
    randomAva() {
      this.user = this.$store.state.user.id + '';
      this.menus = {rows:JSON.parse(localStorage.getItem('vue_store_menu'))};
    },
    fun_calc_select(){
      const _this = this;
      const _ns = this.menus.rows.filter(n=>{
        const param = JSON.stringify(fun_convert_to_string(JSON.parse(n.functionParameter)));
        return n.url==_this.$route.path&&param==JSON.stringify(_this.$route.query);
      });
      if (_ns.length>0) this.current_code = _ns[0].levelCode;
    },
  },
  mounted() {
    const _this = this;
    this.current_user = this.$store.state.user;
    this.randomAva();
    this.common_sys_name = process.env.VUE_APP_SYSTEM_NAME;
    document.title = this.common_sys_name;
    this.$router.afterEach((to, from) => {
      _this.fun_calc_select();
    });
    _this.fun_calc_select();
  },
  updated() {
  }
};
</script>

<style scoped>
</style>
